var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCorrectiveActionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7201 2.49982L18.6587 16.2498C18.8889 16.6484 18.7523 17.1581 18.3537 17.3882C18.227 17.4613 18.0833 17.4998 17.937 17.4998H2.0599C1.59966 17.4998 1.22656 17.1268 1.22656 16.6665C1.22656 16.5202 1.26507 16.3765 1.33821 16.2498L9.27679 2.49982C9.50687 2.10123 10.0165 1.96468 10.4151 2.19479C10.5418 2.26793 10.647 2.37313 10.7201 2.49982ZM3.50327 15.8332H16.4936L9.99845 4.58315L3.50327 15.8332ZM9.16512 13.3332H10.8318V14.9998H9.16512V13.3332ZM9.16512 7.49982H10.8318V11.6665H9.16512V7.49982Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCorrectiveActionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CorrectiveActionIcon.abcab457.svg";
export { ForwardRef as ReactComponent };